import { render, staticRenderFns } from "./HubOrganization.vue?vue&type=template&id=600126df&scoped=true"
import script from "./HubOrganization.vue?vue&type=script&lang=js"
export * from "./HubOrganization.vue?vue&type=script&lang=js"
import style0 from "./HubOrganization.vue?vue&type=style&index=0&id=600126df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600126df",
  null
  
)

export default component.exports